export default __webpack_public_path__ + "static/coloredited_danalim_data_cafe3-07e3168e46d369c43de8c335a8b9ded6.png";